import classNames from 'classnames';
import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface Props extends React.PropsWithChildren {
    className?: string;
    withInterest?: boolean;
}

const AccountViewSkeleton: FC<Props> = ({ className, withInterest = false, children }) => {
    return (
        <div className={classNames('sgw-account-details skeleton', className)}>
            <section className="sgw-account-details__meta account-view__balance-container">
                <dl className="sgw-account-details__wrapper">
                    <dd className="account-details__amount balance-wrapper">
                        <span className="balance-title">
                            <Skeleton width={30} height={25} />
                        </span>

                        <Skeleton width={220} height={42} />

                        <div className="account-balance__progress-bar">
                            <Skeleton width="90%" height={8} />
                        </div>
                        <div className="account-balance__progress-text">
                            <Skeleton width={200} height={23} />
                        </div>
                        {withInterest && children}
                    </dd>
                </dl>
                <div className="background-wrapper">
                    <div className="background" />
                </div>
            </section>
        </div>
    );
};

export default AccountViewSkeleton;
